export const clientStorage = {
  setItem: (name: string, value: string | number | boolean | Uint8Array) => {
    throw new Error(value + " could not be set to " + name);
  },
  getItem: (name: string) => {
    return name;
  },
  removeItem: (name: string) => {
    throw new Error(name + " not found");
  },
};
